import React from "react";
import { formatDate, formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS } from "../../Utils/data&dateTime";
import collegeLogo from "../../assets/Images/college-logo.png";
import "../../assets/css/Modal.css";
import "../../assets/css/StudentShortDetails.css";

import directorSign from '../../assets/Images/Dir_signatures.jpeg'
import { formatCourseListWithRoman, formatCourseListWithRomanString } from "../../Utils/ConvertRoman";
const FeeNoticeStudentsWise = ({ course, isOpen, onClose, noticeData, students }) => {



    // console.log("noticeData===>>", noticeData)
    // console.log("Students===", students)
    // ✅ unify student/fee list depending on which prop is passed
    const feeList = noticeData?.feeDetails || students || [];
    const pendingCount = feeList?.length || 0;

    // Message to share
    const shareMessage = `Fee Notice for ${course?.label}:\n
There are ${pendingCount} students with pending dues.\n
Failure to submit fees by the due date will attract a ₹100/day penalty.\n
- Banaras Institute of Teachers Education, Varanasi`;

    const handleShare = () => {
        if (navigator.share) {
            navigator
                .share({
                    title: "Fee Notice",
                    text: shareMessage,
                    url: window.location.href,
                })
                .catch((err) => console.error("Share failed:", err));
        } else {
            const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareMessage)}`;
            window.open(whatsappUrl, "_blank");
        }
    };



    const handlePrintNotice = () => {
        onClose(); // close modal first
        const printContent = document.getElementById("print-wrapper");
        if (!printContent) return;
        const newWindow = window.open("width=800,height=1100");

        newWindow.document.write(`
        <html>
        <head>
            <title>Fee Notice</title>
            <style>
 
                  body {
             
                     font-family: "Poppins", "Roboto", sans-serif;
                    padding: 40px 0;
                    color: #000000;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                    background: #ffffff;
                    }

                .print-container {
            width: 600px;
            margin: 0 auto;
          }
          .notice-page {
            page-break-after: always;
            border: none !important;
            padding: 20px;
            margin-bottom: 20px;
          }
 

         .date-cintainer{
         display: flex;
    justify-content: space-between;    }
         .due-date{
         font-weight: bold
         }

          .notice-page {
            page-break-after: always; /* ensures each notice prints on a new page */
            margint-top:10px

           
          }
          h5, h6 { text-align: center; }
          .text-center { text-align: center; }
          .noticedetails p { margin: 5px 0; font-size: 17px; }
                 .collegenameTitle { font-size: 18px; font-weight: bold;margin-top:0px !important; margin-bottom:0px  !important}
          .affiliateTitle { font-size: 14px !important; font-weight: 600; margin-top: 0px !important; margin-bottom:0px  !important }
              strong { font-weight: 500 !important;font-size: 16px !important }
          .approvals{font-size: 17px !important; font-weight: 600 !important; }
          .no-print { display: none !important; }
            .delay{margin-top:0px !important; margin-bottom:2px  !important}
            .due-date{font-weight: bold !important;}
             .importanrtP{ margin-bottom: 2px !important;font-weight: bold !important;}
          
        </style>
      </head>
      <body>
        <div class="print-container">
          ${printContent.innerHTML}
        </div>
      </body>
    </html>
  `);

        newWindow.document.close();
        // ✅ Fix: Wait for image load before printing
        newWindow.onload = () => {
            const logoImg = newWindow.document.getElementById("collegeLogo");

            if (logoImg && !logoImg.complete) {
                logoImg.onload = () => {
                    newWindow.focus();
                    newWindow.print();
                    newWindow.close();
                };
            } else {
                newWindow.focus();
                newWindow.print();
                newWindow.close();
            }
        };


        if (typeof onClose === "function") {
            onClose();
        }
    };

    const courseList = Array.from(students?.course_names || []);
    const courseNames = formatCourseListWithRoman(courseList);


    if (!isOpen) return null;

    return (
        <div id="print-wrap" style={{ width: "100%", overflowX: "auto", padding: "20px" }} className="feenotice-print-wrap">
            <div className="modal-overlay view-feenotice-print-modal feenotice-overlay">
                <div className="print-areass feenotice-print-area">
                    <div
                        className="modal-content scheduleformprint feenotice-container mt-1"
                        style={{
                            maxHeight: "85vh",
                            overflowY: "auto",
                            padding: "20px",
                            backgroundColor: "white",
                            boxSizing: "border-box",
                            borderRadius: "8px",
                            width: "75vw",
                            margin: "auto",
                            position: "relative",
                        }}
                    >
                        <div className="modal-title d-flex justify-content-end align-items-center">
                            <button
                                className="close-btn no-print"
                                onClick={onClose}
                                aria-label="Close"
                                style={{
                                    color: "black",
                                    border: "none",
                                    background: "transparent",
                                    fontSize: "18px",
                                }}
                            >
                                ✖
                            </button>
                        </div>


                        <div id="print-wrapper" >
                            {
                                students?.course_mode?.toLowerCase()?.includes("individual") ? (
                                    students?.students_list?.map((student, idx) => (
                                        <div key={idx} className="notice-page feenotice-page" style={{ border: '1px solid', padding: '20px' }}>
                                            {/* Header */}
                                            <div className="page-info" style={{ textAlign: "right", fontSize: "12px", color: "gray" }}>
                                                Notice {idx + 1} of {students.students_list.length}
                                            </div>

                                            <div className="print-header">
                                                <div className="text-center imageLogoCollege">
                                                    <img src={collegeLogo} width={120} height={120} />
                                                </div>
                                                <h5
                                                    style={{ fontWeight: "bold", color: "black", textAlign: "center" }}
                                                    className="collegenameTitle mt-2"
                                                >
                                                    Banaras Institute of Teacher's Education
                                                </h5>
                                                <p
                                                    style={{
                                                        fontStyle: "italic",
                                                        textAlign: "center",
                                                        color: "black",
                                                        fontWeight: "600",
                                                        fontSize: "14px",
                                                    }}
                                                    className="mt-1 mb-1 affiliateTitle"
                                                >
                                                    (Affiliated with "Mahatma Gandhi Kashi Vidyapith, Varanasi")
                                                </p>
                                                <p className="mb-5 Babatpur" style={{ fontWeight: "bold", textAlign: "center" }}>Babatpur, Varanasi</p>
                                            </div>

                                            {/* Notice Date + Doc No */}
                                            <div className="notice-date d-flex justify-content-between date-cintainer">
                                                <p className="noticedetails">
                                                    <strong style={{ fontSize: "14px", fontWeight: "600" }} className="due-date">
                                                        Ref No:{" "}
                                                        <span style={{ fontWeight: "400" }}>
                                                            {students?.document_number || students?.id}
                                                        </span>
                                                    </strong>
                                                </p>
                                                <p className="noticedetails">
                                                    <strong style={{ fontSize: "14px", fontWeight: "600", color: "black" }} className="due-date">
                                                        Date:{" "}
                                                        <span style={{ fontWeight: "400" }}>
                                                            {formatDateDDMMYYYYHHMMSS(students.created_at)}
                                                        </span>
                                                    </strong>
                                                </p>

                                            </div>
                                            <p className="mb-5 mt-1" style={{ fontWeight: "bold", textAlign: "center", textDecoration: 'underline', fontSize: '20px' }}>Important Notice</p>
                                            {/* Message */}
                                            {/* <p className="noticedetails mt-3" style={{ color: "black" }}>
                                                This is to inform <strong>{student.student_name}</strong> (Reg:{" "}
                                                {student.student_registration}), a student of{" "}
                                                <strong>{students.full_course_name}</strong>, that he/she must pay the{" "}
                                                <strong>{students.fee_head_names}</strong> of{" "}
                                                <strong className="due-date">₹{students.amount || 0}</strong> on or before{" "}
                                                <strong className="due-date">{formatDateDDMMYYYY(students.due_date)}</strong>.
                                            </p> */}
  
                                            <p className="noticedetails mt-3" style={{ color: "black" }}>
                                                This is to inform <strong>{student.student_name}</strong>, a student of{" "}
                                                <strong> {formatCourseListWithRomanString(students.full_course_name)}</strong>, that he/she is required to deposit
                                                their pending fees by{" "}
                                                <strong className="due-date">
                                                    {formatDate(new Date(students.due_date))}
                                                </strong>.
                                            </p>


                                            {/* Important Section */}
                                            {(students.penalty_per_day > 0 || students.max_penalty > 0) && (
                                                <div className="d-flex gap-3">
                                                    <p className="noticedetails">
                                                        <p className="mt-2 importanrtP">
                                                            <strong className="due-date">Important:</strong>
                                                        </p>
                                                        <br />
                                                        {students.penalty_per_day > 0 && (
                                                            <p style={{ marginLeft: "20px" }} className="delay">
                                                                • Delay in payment will attract a{" "}
                                                                <strong className="due-date">penalty of ₹{students.penalty_per_day}</strong> per day,
                                                                subject to a maximum of ₹
                                                                <strong className="due-date">{students.max_penalty}.</strong>
                                                            </p>
                                                        )}
                                                        <p style={{ marginLeft: "20px" }} className="delay">
                                                            • Student is advised to pay the fee within the stipulated time to avoid{" "}
                                                            <strong className="due-date">penalties.</strong>
                                                        </p>
                                                    </p>
                                                </div>
                                            )}


                                            {/* Signatures */}
                                            <div
                                                className="signatures-block"
                                                style={{
                                                    marginTop: "20px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "space-between",
                                                    gap: "40px",
                                                }}
                                            >
                                                {/* Row 1: Director (Right Aligned) */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        width: "100%",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            textAlign: "right",
                                                            width: "fit-content",
                                                        }}
                                                    >
                                                        <img
                                                            src={directorSign}
                                                            alt="Director's Signature"
                                                            style={{
                                                                width: "180px",
                                                                height: "auto",
                                                                display: "block",
                                                                marginLeft: "auto",
                                                            }}
                                                        />
                                                        <div className="approvals" style={{ fontWeight: "bold", textAlign: "center" }}>
                                                            Director
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Row 2: Copy To (Left Aligned) */}
                                                {students?.copied_to?.length > 0 && (
                                                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                                        <div style={{ textAlign: "left" }}>
                                                            <strong style={{ display: "block", marginBottom: "6px" }}>Copy to:</strong>
                                                            <ol
                                                                style={{
                                                                    margin: 0,
                                                                    paddingLeft: "20px",
                                                                    lineHeight: "1.6",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                {students.copied_to.map((item, idx) => (
                                                                    <li key={idx}>
                                                                        {item.designation_id}
                                                                        {item.reason ? ` (${item.reason})` : ""}
                                                                    </li>
                                                                ))}
                                                            </ol>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <>
                                        {noticeData?.course_mode === false ? (
                                            noticeData?.feeDetails?.map((schedule, idx) => (
                                                <div key={idx} className="notice-page feenotice-page" style={{ border: '1px solid', padding: '20px' }}>
                                                    {/* Header */}
                                                    <div className="page-info" style={{ textAlign: "right", fontSize: "12px", color: "gray" }}>
                                                        Notice {idx + 1} of {noticeData.feeDetails.length}
                                                    </div>

                                                    <div className="print-header">
                                                        <div className="text-center imageLogoCollege">
                                                            <img src={collegeLogo} width={120} height={120} />
                                                        </div>
                                                        <h5 className="collegenameTitle mt-2" style={{ fontWeight: "bold", color: "black", textAlign: "center" }}>
                                                            Banaras Institute of Teacher's Education
                                                        </h5>
                                                        <p
                                                            style={{
                                                                fontStyle: "italic",
                                                                textAlign: "center",
                                                                color: "black",
                                                                fontWeight: "500",
                                                                fontSize: "14px",
                                                            }}
                                                            className="mt-1 affiliateTitle"
                                                        >
                                                            (Affiliated with Mahatma Gandhi Kashi Vidyapith, Varanasi)
                                                        </p>
                                                        <p className="mb-5 Babatpur" style={{ fontWeight: "bold", textAlign: "center" }}>Babatpur, Varanasi</p>
                                                    </div>

                                                    {/* Notice Date + Doc No */}

                                                    <div className="notice-date d-flex justify-content-between date-cintainer">
                                                        <p className="noticedetails">
                                                            <strong style={{ fontSize: "14px", fontWeight: "600" }} className="due-date">
                                                                Ref No: <span style={{ fontWeight: "400" }}>{schedule.document_number}</span>
                                                            </strong>
                                                        </p>
                                                        <p className="noticedetails">
                                                            <strong style={{ fontSize: "14px", fontWeight: "600", color: "black" }} className="due-date">
                                                                Date:{" "}
                                                                <span style={{ fontWeight: "400" }}>{formatDateDDMMYYYYHHMMSS(noticeData.createdDate)}</span>
                                                            </strong>
                                                        </p>

                                                    </div>


                                                    <p className="mb-5 mt-1" style={{ fontWeight: "bold", textAlign: "center", textDecoration: 'underline', fontSize: '20px' }}>Important Notice</p>

                                                    {/* Message */}
                                                    {/* <p className="noticedetails mt-3" style={{ color: "black" }}>
                                                        This is to inform <strong>{schedule.student_name}</strong> (Reg: <strong>{schedule.registration_number}</strong>),
                                                        a student of <strong>{schedule.course_name}</strong>, has to pay <strong>{schedule.fee_head_name}</strong> of <strong className="due-date">₹{schedule.amount}</strong>
                                                        and must be paid on or before <strong className="due-date"> before{formatDateDDMMYYYY(schedule.due_date)}</strong>.
                                                    </p> */}

                                                    <p className="noticedetails mt-3" style={{ color: "black" }}>
                                                        This is to inform  <strong>{schedule.student_name}</strong>, a student of{" "}
                                                        <strong>{schedule.course_name}</strong>,that he/she is required to deposit their
                                                        pending fees by{" "}
                                                        <strong className="due-date">
                                                            {formatDate(new Date(schedule.due_date))}</strong>.
                                                    </p>



                                                    {/* Important Section */}
                                                    {noticeData?.pendingPayload?.penalty_per_day > 0 && (
                                                        <div className="d-flex gap-3">
                                                            <p className="noticedetails">
                                                                <p className="mt-2 importanrtP">
                                                                    <strong className="due-date">Important:</strong>
                                                                </p>
                                                                <br />
                                                                <p style={{ marginLeft: "20px" }} className="delay">
                                                                    • Delay in payment will attract a <strong className="due-date">penalty of </strong>
                                                                    <strong className="due-date">₹{noticeData?.pendingPayload?.penalty_per_day}</strong> per day,
                                                                    subject to a maximum of ₹
                                                                    <strong className="due-date">{noticeData?.pendingPayload?.max_penalty}.</strong>
                                                                </p>
                                                                <p style={{ marginLeft: "20px" }} className="delay">
                                                                    • Student is advised to pay the fee within the stipulated time to avoid{" "}
                                                                    <strong className="due-date">penalties.</strong>
                                                                </p>
                                                            </p>
                                                        </div>
                                                    )}

                                                    <div
                                                        className="signatures-block"
                                                        style={{
                                                            marginTop: "20px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "space-between",
                                                            gap: "40px", // spacing between the two rows
                                                        }}
                                                    >
                                                        {/* Row 1: Director (Right Aligned) */}

                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "flex-end",
                                                                width: "100%", // ensure full width
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    textAlign: "right",
                                                                    width: "fit-content", // prevent shrinking
                                                                }}
                                                            >
                                                                <img
                                                                    src={directorSign}
                                                                    alt="Director's Signature"
                                                                    style={{
                                                                        width: "180px",
                                                                        height: "auto",
                                                                        display: "block",
                                                                        marginLeft: "auto", // ensures image pushes right inside container
                                                                    }}
                                                                />
                                                                <div className="approvals" style={{ fontWeight: "bold", textAlign: "center" }}>
                                                                    Director
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {noticeData?.copy_to_details?.length > 0 && (
                                                            <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                                                <div style={{ textAlign: "left" }}>
                                                                    <strong style={{ display: "block", marginBottom: "6px" }}>Copy to:</strong>
                                                                    <ol
                                                                        style={{
                                                                            margin: 0,
                                                                            paddingLeft: "20px",
                                                                            lineHeight: "1.6",
                                                                            fontSize: "14px",
                                                                        }}
                                                                    >
                                                                        {noticeData.copy_to_details.map((item, idx) => (
                                                                            <li key={idx}>
                                                                                {item.designation}
                                                                                {item.reason ? ` (${item.reason})` : ""}
                                                                            </li>
                                                                        ))}
                                                                    </ol>
                                                                </div>
                                                            </div>
                                                        )}


                                                    </div>


                                                </div>
                                            ))
                                        ) : (
                                            ""
                                        )}
                                    </>
                                )}


                        </div>
                        {/* Footer Buttons */}
                        <div
                            className="no-print"
                            style={{
                                position: "sticky",
                                bottom: 0,
                                width: "100%",
                                padding: "15px 25px",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "10px",
                                background: "white",
                                zIndex: 10, 
                                /* REMOVE border & create smooth shadow */
                                borderTop: "none",
                                boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.08)",
                            }}
                        >
                            <button
                                onClick={handleShare}
                                className="btn btn-success"
                                style={{ padding: "8px 20px", fontSize: "16px", cursor: "pointer" }}
                            >
                                Share
                            </button>

                            <button
                                onClick={handlePrintNotice}
                                className="add-btn"
                                style={{ padding: "8px 20px", fontSize: "16px", cursor: "pointer" }}
                            >
                                Print
                            </button>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeeNoticeStudentsWise;
